import React, { useState, useEffect } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const LanguageToggle = () => {
  const [currentLanguage, setCurrentLanguage] = useState('en');
  const [isOpen, setIsOpen] = useState(false);

  const languages = [
    { code: 'en', name: 'English', flag: '🇺🇸', nativeName: 'English' },
    { code: 'ar', name: 'Arabic', flag: '🇸🇦', nativeName: 'العربية' }
  ];

  useEffect(() => {
    const savedLanguage = localStorage.getItem('language') || 'en';
    setCurrentLanguage(savedLanguage);
    
    // Apply RTL/LTR to document
    document.documentElement.dir = savedLanguage === 'ar' ? 'rtl' : 'ltr';
    document.documentElement.lang = savedLanguage;
  }, []);

  const handleLanguageChange = (languageCode) => {
    setCurrentLanguage(languageCode);
    localStorage.setItem('language', languageCode);
    
    // Apply RTL/LTR to document
    document.documentElement.dir = languageCode === 'ar' ? 'rtl' : 'ltr';
    document.documentElement.lang = languageCode;
    
    setIsOpen(false);
    
    // Trigger a custom event to notify other components
    window.dispatchEvent(new CustomEvent('languageChanged', { detail: languageCode }));
    
    // Reload the page to apply language changes
    window.location?.reload();
  };

  const currentLang = languages?.find(lang => lang?.code === currentLanguage);

  return (
    <div className="fixed top-20 right-4 z-50">
      <div className="relative">
        <Button
          variant="outline"
          size="sm"
          onClick={() => setIsOpen(!isOpen)}
          className="bg-card/95 backdrop-blur-sm border-border shadow-lg"
        >
          <span className="mr-2">{currentLang?.flag}</span>
          <span className="hidden sm:inline">{currentLang?.nativeName}</span>
          <span className="sm:hidden">{currentLang?.code?.toUpperCase()}</span>
          <Icon 
            name={isOpen ? "ChevronUp" : "ChevronDown"} 
            size={16} 
            className="ml-2" 
          />
        </Button>

        {isOpen && (
          <>
            {/* Backdrop */}
            <div 
              className="fixed inset-0 z-40"
              onClick={() => setIsOpen(false)}
            />
            
            {/* Dropdown */}
            <div className="absolute top-full mt-2 right-0 w-48 bg-popover border border-border rounded-lg shadow-elevated py-2 z-50">
              {languages?.map((language) => (
                <button
                  key={language?.code}
                  onClick={() => handleLanguageChange(language?.code)}
                  className={`w-full px-4 py-3 text-left hover:bg-muted transition-colors duration-200 flex items-center space-x-3 ${
                    currentLanguage === language?.code ? 'bg-muted text-primary' : 'text-popover-foreground'
                  }`}
                >
                  <span className="text-lg">{language?.flag}</span>
                  <div className="flex-1">
                    <div className="font-medium">{language?.nativeName}</div>
                    <div className="text-xs text-muted-foreground">{language?.name}</div>
                  </div>
                  {currentLanguage === language?.code && (
                    <Icon name="Check" size={16} color="var(--color-primary)" />
                  )}
                </button>
              ))}
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default LanguageToggle;